module.exports = "<h1 id=\"17-行动值变化--行動順変化\">17. 行动值变化 / 行動順変化</h1>\n<p><strong><code>OrderChange</code>。</strong>未出现过</p>\n";